import React from 'react';
import { Modal, Row, Col, Typography, Image, Table } from 'antd';
import ButtonItem from '../../../../../Components/ButtonItem';
import InputItem from '../../../../../Components/InputItem';
const { Title, Text } = Typography;

class ModalBusquedaAvanzada extends React.Component {
  state = {
    selectedInsumoId: null, 
  };

  handleSelectInsumo = (insumoId) => {
    this.setState({ selectedInsumoId: insumoId });
  };

  handleAceptar = () => {
    const { selectedInsumoId } = this.state;
    if (selectedInsumoId) {
      this.props.onSelectInsumo(selectedInsumoId);
      this.props.onClose(); 
    } else {
      this.props.onClose(); 
    }
  };

  getProductInfo = (selectedInsumo) => {
    if (selectedInsumo) {
      return (
        <Row gutter={16}>
          <Col span={8}>
            <Image
             src={
                selectedInsumo.archivosPrincipal?.[0]
                  ? "../" + selectedInsumo.archivosPrincipal[0]
                  : "/Resources/logoBiwoInsumos.png"
              }              
              alt={"Sin imagen"}
              width={120}
              style={{ borderRadius: '8px' }}
            />
          </Col>
          <Col span={16}>
            <Text strong>Nombre: </Text>{selectedInsumo.stringBuscar}<br />
            <Text strong>Código: </Text>{selectedInsumo.codigoBarras}<br />
            <Text strong>Descripción: </Text>{selectedInsumo.descripcionLarga}<br />
            <Text strong>Unidad: </Text>{selectedInsumo.unidad}<br />
            <Text strong>Precio: </Text>{selectedInsumo.precios[0]?.precio || 'No disponible'}<br />
            <Text strong>Inventario: </Text>{selectedInsumo.cantidadProyecto}<br />
          </Col>
        </Row>
      );
    }
    return null;
  };

  render() {
    const { visible, onClose, insumos } = this.props;

    const validInsumos = Array.isArray(insumos) ? insumos : [];

    const defaultInsumo = validInsumos[0];
    const selectedInsumo = validInsumos.find((insumo) => insumo._id === this.state.selectedInsumoId) || defaultInsumo;

    const columns = [
      {
        title: 'Imagen',
        dataIndex: 'archivosPrincipal',
        key: 'imagen',
        render: (text, record) => (
            <Image
            src={
              record.archivosPrincipal?.[0]
                ? "../" + record.archivosPrincipal[0]
                : "/Resources/logoBiwoInsumos.png"
            }
            alt={"Sin imagen"}
            width={50}
            style={{ borderRadius: '8px' }}
          />
        ),
      },
      {
        title: 'Nombre',
        dataIndex: 'stringBuscar',
        key: 'stringBuscar',
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
              <InputItem
                placeholder="Buscar nombre"
                value={selectedKeys[0]}
                onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                onPressEnter={confirm}
                style={{ width: 188, marginBottom: 8, display: 'block' }}
              />
              <ButtonItem type="primary" onClick={confirm} size="small" style={{ width: 90, marginRight: 8 }}>
                Buscar
              </ButtonItem>
              <ButtonItem onClick={clearFilters} size="small" style={{ width: 90 }}>
                Limpiar
              </ButtonItem>
            </div>
          ),
          onFilter: (value, record) =>
            record.stringBuscar?.toString().toLowerCase().includes(value.toLowerCase()),
        render: text => <Text>{text}</Text>,
      },
      {
        title: 'Código',
        dataIndex: 'codigoBarras',
        key: 'codigoBarras',
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
            <InputItem
              placeholder="Buscar código"
              value={selectedKeys[0]}
              onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={confirm}
              style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <ButtonItem type="primary" onClick={confirm} size="small" style={{ width: 90, marginRight: 8 }}>
              Buscar
            </ButtonItem>
            <ButtonItem onClick={clearFilters} size="small" style={{ width: 90 }}>
              Limpiar
            </ButtonItem>
          </div>
        ),
        filterIcon: (filtered) => <span role="img" aria-label="filter">🔍</span>,
        onFilter: (value, record) =>
          record.codigoBarras?.toString().toLowerCase().includes(value.toLowerCase()),
        render: text => <Text>{text}</Text>,
      },
      {
        title: 'Precio',
        dataIndex: 'precios',
        key: 'precio',
        render: (text, record) => <Text>{record.precios[0]?.precio || 'No disponible'}</Text>,
      },
      {
        title: 'Seleccionar',
        key: 'select',
        render: (text, record) => (
          <ButtonItem
            type="primary"
            size="small"
            onClick={() => this.handleSelectInsumo(record._id)}
            style={{ marginTop: 4 }}
          >
            Seleccionar
          </ButtonItem>
        ),
      },
    ];

    return (
      <Modal
        title={
          <Title level={4} style={{ marginBottom: 0 }}>
            Búsqueda Avanzada de Insumos
          </Title>
        }
        visible={visible}
        onCancel={onClose}
        footer={[
          <ButtonItem key="back" onClick={onClose} rojo style={{ width: '120px' }}>
            Cancelar
          </ButtonItem>,
          <ButtonItem key="submit" type="primary" onClick={this.handleAceptar} style={{ width: '120px' }}>
            Aceptar
          </ButtonItem>,
        ]}
        width={1400}  
        bodyStyle={{ padding: '24px' }}
      >
        {this.getProductInfo(selectedInsumo)}

        <Row style={{ marginTop: 24 }}>
          <Col span={24}>
            <Title level={5}>Selecciona un Insumo</Title>
            <Table
            key={visible ? 'open' : 'closed'} 
              rowKey="_id"
              columns={columns}
              dataSource={validInsumos}
              pagination={false}
              scroll={{ y: 300 }} 
              style={{ marginTop: 16 }}
              onRow={(record) => ({
                onClick: () => this.handleSelectInsumo(record._id), 
              })}
            />
          </Col>
        </Row>
      </Modal>
    );
  }
}

export default ModalBusquedaAvanzada;
